/**
 * menu-hover-delay.js
 *
 * Keeps a desktop nav dropdown open while the cursor is anywhere inside its
 * top-level <li> (the trigger, the dropdown panel, any submenu, any item),
 * with a grace delay before closing once the cursor truly leaves.
 *
 * Approach: delegated mouseover on document. On every cursor move, we look
 * up to find which (if any) top-level <li.site-nav--has-dropdown> contains
 * the event target. The dropdown panel and all submenu items are DOM
 * descendants of that <li>, so .contains() answers "is the cursor still in
 * this dropdown's region" correctly even when the visual layout puts the
 * panel outside the trigger's bounding box.
 *
 * Why mouseover instead of mouseenter/mouseleave on the parent: native
 * mouseleave occasionally fires in this theme even when the cursor moves
 * to a DOM descendant (probably because the mega-menu's invalid <div>
 * inside <ul> markup interacts oddly with hoverintent's mouseout tracking
 * and other handlers). mouseover bubbles, fires on every transition, and
 * lets us answer the containment question fresh each time.
 *
 * jQuery's three filtered-mouseout 'mouseleave' close handlers (on
 * .site-header, .site-nav__dropdown, and each parent <li>) are still
 * blocked here via a capture-phase mouseout listener on .site-header so
 * they cannot snap the menu shut between our mouseover events.
 */
(function () {
  'use strict';

  var GRACE_MS = 600;

  function init() {
    var nav = document.getElementById('AccessibleNav');
    if (!nav) return;
    var siteHeader = document.querySelector('.site-header');
    if (!siteHeader) return;

    var parents = Array.prototype.slice.call(
      nav.querySelectorAll(':scope > .site-nav--has-dropdown')
    );
    if (!parents.length) return;

    siteHeader.addEventListener('mouseout', function (e) {
      e.stopImmediatePropagation();
    }, true);

    var currentHover = null;
    var timer = null;

    function setStickyOpen() {
      if (siteHeader.classList.contains('overlay-header')) {
        document.querySelectorAll('.sticky-header').forEach(function (el) {
          el.classList.remove('sticky-header-open');
        });
      }
    }

    function setStickyClosedIfNoOpen() {
      if (!document.querySelector('.nav-hover')) {
        document.querySelectorAll('.sticky-header').forEach(function (el) {
          el.classList.add('sticky-header-transformed');
        });
      }
    }

    function open(parent) {
      if (currentHover && currentHover !== parent) {
        currentHover.classList.remove('nav-hover');
      }
      if (!parent.classList.contains('nav-hover')) {
        parent.classList.add('nav-hover');
        document.querySelectorAll('.sticky-header').forEach(function (el) {
          el.classList.remove('sticky-header-transformed');
        });
      }
      currentHover = parent;
    }

    function scheduleClose() {
      if (!currentHover) return;
      if (timer) clearTimeout(timer);
      var toClose = currentHover;
      timer = setTimeout(function () {
        toClose.classList.remove('nav-hover');
        setStickyOpen();
        setStickyClosedIfNoOpen();
        if (currentHover === toClose) currentHover = null;
        timer = null;
      }, GRACE_MS);
    }

    function findParent(target) {
      for (var i = 0; i < parents.length; i++) {
        if (parents[i].contains(target)) return parents[i];
      }
      return null;
    }

    document.addEventListener('mouseover', function (e) {
      var p = findParent(e.target);
      if (p) {
        if (timer) { clearTimeout(timer); timer = null; }
        open(p);
      } else if (currentHover) {
        scheduleClose();
      }
    }, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
